import React from 'react';
import { Calendar } from './Calendar';
import { TopBar } from '../navigation/TopBar';

export function CalendarPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <TopBar />
      
      <div className="pt-20">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Calendar</h1>
            <p className="text-gray-600 mt-1">View all your projects, jobs, entries, and data in one place</p>
          </div>
          
          <Calendar />
        </div>
      </div>
    </div>
  );
}